import { create } from 'zustand'
import type { DialogId, DynamicDialogId } from '~/types/common'

type AppDialogId = DialogId | DynamicDialogId

type AppState = {
  openDialogIds: AppDialogId[]
  executingDialogIds: AppDialogId[]
  openDialog: (id: AppDialogId) => void
  closeDialog: (id: AppDialogId) => void
  addExecutingDialogId: (id: AppDialogId) => void
  removeExecutingDialogId: (id: AppDialogId) => void
  resetState: () => void
}

const initialState = {
  openDialogIds: [] as AppDialogId[],
  executingDialogIds: [] as AppDialogId[],
}

export const useAppStore = create<AppState>((set) => ({
  ...initialState,
  openDialog: (id: AppDialogId) =>
    set((state) => ({
      openDialogIds: [...state.openDialogIds, id],
    })),
  closeDialog: (id: AppDialogId) =>
    set((state) => ({
      openDialogIds: state.openDialogIds.filter((dialogId) => dialogId !== id),
    })),
  addExecutingDialogId: (id: AppDialogId) =>
    set((state) => ({
      executingDialogIds: [...state.executingDialogIds, id],
    })),
  removeExecutingDialogId: (id: AppDialogId) =>
    set((state) => ({
      executingDialogIds: state.executingDialogIds.filter((dialogId) => dialogId !== id),
    })),
  resetState: () => set(initialState),
}))
